import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useEffect, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useUserLocation } from '~/context/common/UserContext';
import MegaEventContext from '~/context/home/MegaEventContext';

export default function useTrackMegaVehicle() {
  const { triggerVehicleEvent, vehicles } = useContext(MegaEventContext);
  const { isFromCookies, source, zip } = useUserLocation();
  const trackEvent = useTrackEvent();

  const vehiclesRef = useRef(vehicles);
  useEffect(() => {
    vehiclesRef.current = vehicles;
  }, [vehicles]);

  useSubsequentEffect(() => {
    trackEvent(
      'mega-home-vehicle-data',
      {
        isZipFromCookies: isFromCookies,
        vehicles: vehiclesRef.current,
        zip,
        zipSource: source
      },
      undefined,
      {
        useFetch: true,
        fetchOption: { keepalive: false }
      }
    );
  }, [isFromCookies, source, trackEvent, triggerVehicleEvent, zip]);
}
